import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { useSelector, useDispatch, connect } from "react-redux";

import { Link } from "react-router-dom";

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";
// reactstrap
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import megamenuImg from "../../assets/images/megamenu-img.png";
import logo from "../../assets/images/logo.svg";
import logoLight from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.png";

//i18n
import { withTranslation } from "react-i18next";

import {
  useQueryClient,
  useQuery,
} from "react-query";

import {
  getMasterSystems
} from "../../helpers/fakebackend_helper";

import {
  // getTodo as onGetTodo,
  getProfile as onGetProfile
} from "../../store/actions";

const Header = props => {

  const dispatch = useDispatch();

  const { todos } = useSelector(state => ({
    todos: state.Dashboard.todos
  }));

  // useEffect(() => {
  //   dispatch(onGetTodo());
  // }, [onGetTodo]);

  const { profile } = useSelector(state => ({
    profile: state.Dashboard.profile
  }));

  useEffect(() => {
    dispatch(onGetProfile());
  }, [onGetProfile]);

  const [menu, setMenu] = useState(false);
  const [isSearch, setSearch] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["masterResource"],queryFn: getMasterSystems
  });

  if (isLoading) return "Loading...";

  if (error) return "An error has occurred: " + error.message;

  const themeConfig = {
    logo: 'https://prod-temperstack-public-assets.s3.ap-south-1.amazonaws.com/temperstack-logos/temperstack-logo.png',
  }

  return (
    <React.Fragment>
      <header id="page-topbar mb-1" style={{backgroundColor:"#4d43486a", backdropFilter:"blur(20px)", position:"relative", zIndex:"9999"}}>
        <div className="navbar-header" style={{height:"60px"}}>
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={themeConfig?.logo} alt="Temperstack-Logo" height="26" />
                </span>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="logo-lg">
                    <img src={themeConfig?.logo} alt="Temperstack-Logo" height="30" style={{ margin: '2px 5px 0 0' }} />
                  </span>
                  {/*<span style={{ fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '18px', color: '#ffffff' }}>BlueJay</span>*/}
                </div>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={themeConfig?.logo} alt="Temperstack-Logo" height="26" />
                </span>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="logo-lg">
                    <img src={themeConfig?.logo} alt="Temperstack-Logo" height="30" style={{ margin: '2px 5px 0 0' }} />
                  </span>
                  {/*<span style={{ fontFamily: 'IBM Plex Sans, sans-serif', fontSize: '18px', color: '#ffffff' }}>BlueJay</span>*/}
                </div>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>

          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
                onClick={() => setSearch(!isSearch)}
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  isSearch
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.t("Search") + "..."}
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* <Dropdown
              className="d-none d-lg-inline-block ms-1"
              isOpen={socialDrp}
              toggle={() => {
                setsocialDrp(!socialDrp);
              }}
            >
              <DropdownToggle
                className="btn header-item noti-icon "
                caret
                tag="button"
              >
                <i className="bx bx-customize" />
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
                <div className="px-lg-2">
                  <Row className="no-gutters">
                    {
                      data.map((item, key) => (
                        <Col key={key}>
                          <Link className="dropdown-icon-item" to={"/"+item.name.replace(/\s+/g, '_').toLowerCase()+"/onboarding"}>
                            <img src={item.logo_url} alt={item.name} />
                            <span>{item.name}</span>
                          </Link>
                        </Col>
                      ))
                    }
                  </Row>
                </div>
              </DropdownMenu>
            </Dropdown>

            <NotificationDropdown /> */}

            <ProfileMenu />


          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
